<template>
  <div id="app">
    <header>
      <div class="row">
        <span class="logo"></span>
        <div id="nav">
          <router-link to="/">首页</router-link>
          <router-link to="/applyCredit">积分申请</router-link>
          <router-link to="/audit">
            <el-badge :value="auditInfo.count" :max="99" :hidden="!auditInfo.count" class="item">
              审批查询
            </el-badge>
          </router-link>
          <router-link to="/exchange">兑换</router-link>
          <router-link to="/user">个人</router-link>
          <router-link to="/rule">积分规则</router-link>
        </div>
        <div id="nav-right">
            <a id="login" href="#" @click="loginVisible = true" v-if="!isLogin">非邮箱登陆</a>
            <el-dropdown v-else :hide-on-click="false" @command="handleUserCommand">
              <span class="el-dropdown-link">
                {{ username }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="change_password" v-if="canChange">修改密码</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
      </div>
    </header>
    <!-- 登录对话框 -->
    <LoginDialog :visible.sync="loginVisible" />
    <ChangePasswordDialog :visible.sync="changePasswordVisible" />
    <div id="content">
      <router-view/>
    </div>

    <footer>
      <div class="row row-sm">
        <div class="footer-text">
          欢迎提出宝贵的意见，我们将会为大家做得更好~
        </div>
        <div class="footer-link">
          <a href="mailto:imd@conew.com">imd@conew.com</a>
        </div>
        <div class="footer-copyrighs">
          豹趣科技 &copy; 2025 最终解释权归豹趣科技综合管理部所有
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoginDialog from './components/LoginDialog.vue'
import ChangePasswordDialog from './components/ChangePasswordDialog.vue'
import { redirectLogin } from './utils/oa'

export default {
  name: 'app',
  components: {
    LoginDialog,
    ChangePasswordDialog
  },
  data () {
    return {
      loginVisible: false,
      changePasswordVisible: false
    }
  },
  computed: {
    ...mapState({
      username: state => state.username,
      isLogin: state => state.isLogin,
      canChange: state => state.isLogin && state.isWb,
      auditInfo: state => state.auditInfo && state.auditInfo
    })
  },
  methods: {
    async handleUserCommand (command) {
      try {
        switch (command) {
          case 'change_password':
            this.changePasswordVisible = true
            break
          case 'audit':
            await this.$router.push('/audit')
            break
          case 'logout':
            redirectLogin(window.location.origin, {
              isLogout: true
            })
            break
        }
      } catch (err) {
        if (err.name === 'NavigationDuplicated') {
          window.location.reload()
        }
      }
    }
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  background: #fff url('~@/assets/huawen.png') center no-repeat;
  background-size: 100%;
}

#app {
  position: relative;
  font-family: MicrosoftYaHei, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #2c3e50;
  // color: #ea4809;
  overflow-x: hidden;
  min-width: 1280px;
  margin: 0 auto;
}

.logo {
  display: block;
  width: 176px;
  height: 38px;
  background: url('~@/assets/logo.png') 0 0 no-repeat;
  background-size: 100%;
}

#nav {
  flex: 1;
  position: relative;
  max-width: 1440px;
  a {
    display: inline-block;
    margin-left: 70px;
    line-height: 38px;
    font-size: 22px;
    font-weight: 500;
    letter-spacing: -1px;
    text-transform: uppercase;
    text-decoration: none;
    color: #666;
    &:hover {
      color: #888;
    }
    &::before {
      background: #666;
    }
    &.router-link-exact-active {
      color: #E24140;
      &::before {
        background: #E24140;
      }
    }
  }
}

#nav-right {
  position: absolute;
  top: 30px;
  right: 130px;
  // margin-right: 30px;
  white-space: nowrap;
  a, .el-dropdown-link {
    display: inline-block;
    margin-left: 30px;
    line-height: 38px;
    font-size: 18px;
    font-weight: 500;
    letter-spacing: -1px;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
    color: #fff;
    &:hover {
      color: #ddd;
    }
    &::before {
      background: #fff;
    }
    &.router-link-exact-active {
      color: #E24140;
      &::before {
        background: #E24140;
      }
    }
  }
}

#content {
  width: 1120px;
  min-height: 100vh;
  margin: 0 auto;
}

.morph-wrap {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
  opacity: 1;
  visibility: visible;
  transition: 0.6s;
  .morph {
    left: -300px !important;
  }
  .morph2 {
    left: auto !important;
    right: -200px !important;
    top: 100px !important;
  }
  .morph3 {
    left: auto !important;
    top: auto !important;
    right: -350px !important;
    bottom: -400px !important;
  }
  svg {
    position: absolute;
    top: 0;
    left: 0;
  }
}

header {
  width: 100%;
  position: relative;
  z-index: 2;
  padding: 30px 0;
  .row {
    display: flex;
  }
  #nav {
    // margin-left: 164px;
  }
}

footer {
  position: relative;
  height: 210px;
  background: #F5F6FB;
  text-align: center;
  &::before {
    content: '';
    display: table;
    clear: both;
  }
  .footer-text {
    margin-bottom: 10px;
    padding-top: 68px;
    font-size: 16px;
    color: #959AB7;
  }
  .footer-link {
    margin-bottom: 10px;
    a {
      text-decoration: none;
      font-size: 14px;
      color: #959AB7;
    }
  }
  .footer-copyrighs {
    font-size: 10px;
    color: #B3B8D4;
  }
}

.row {
  padding-left: 30px;
  padding-right: 30px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
}

.row-sm {
  box-sizing: border-box;
  max-width: 1356px;
  width: 90%;
  margin: 0 auto;
  padding-left: 140px;
  padding-right: 140px;
}

.line-through {
  position: relative;
  color: #ea4809;
  &::before {
    content: '';
    position: absolute;
    top: 40%;
    left: -10px;
    height: 3px;
    background: #ea4809;
    width: 0;
    transition: 0.2s cubic-bezier(0.65, 0, 0.17, 0.98);
  }
  &:hover {
    &::before {
      width: calc(100% + 20px);
    }
  }
}
.el-dropdown-menu {
  white-space: nowrap;
}

@media screen and (max-width: 1280px) {
  #nav {
    a {
      margin-left: 50px;
    }
  }
}

@media screen and (min-width: 2100px) {
  #nav-right a, #nav-right .el-dropdown-link {
    color: #666;
  }
}
</style>
